import Immutable from "seamless-immutable";

import {
  SHOW_LOADING,
  HIDE_LOADING,
  SHOW_ERROR,
  UPDATE_ITEMS,
  UPDATE_ITEM_HISTORY,
  CREATE_MANUAL_DONATION
} from "./Types";
import api from "../../api";
import { Roles } from "../../Shared/Constants/Roles";
// Models
// import Item from "../../model/Item";
// Transforms
import { addItem, replaceInItems } from "../../transforms/ItemTransforms";

export function getItems(dropOffOnly, silent = false, rejected = undefined) {
  return async function (dispatch, getState) {
    try {
      if (!silent) dispatch({ type: SHOW_LOADING });

      const result = await api.item.getItems(
        Roles.RECIPIENT,
        true,
        dropOffOnly,
        rejected
      );

      if (result.success) {
        const sortedItems = result.data.sort(
          (a, b) => a.datePosted - b.datePosted
        );

        dispatch({ type: UPDATE_ITEMS, items: sortedItems });
      } else {
        dispatch({ type: SHOW_ERROR, message: result.error });
      }
    } catch (e) {
      console.error(e);
    } finally {
      if (!silent) dispatch({ type: HIDE_LOADING });
    }
  };
}

export function reviseItems(items) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      let { history } = getState().marketplace;
      history = Immutable.asMutable(history);

      const results = await Promise.all(
        items.map(item => {
          try {
            if(Immutable.isImmutable(item)){
              var item = Immutable.asMutable(item);
              item.producerContact = Immutable.isImmutable(item.producerContact) ? Immutable.asMutable(item.producerContact) : item.producerContact;
              item.courierContact = Immutable.isImmutable(item.courierContact) ? Immutable.asMutable(item.courierContact) : item.courierContact;
            }
            delete item?.producerContact?.email;
            delete item?.courierContact?.email;
          } catch (error) {}
          return api.item.reviseItem(item.id, item);
        })
      );

      results.forEach(result => {
        if (!result.success) {
          // don't merge failed item updates
          console.warn(`failed to revise item ${result.data?.id}`);
          return;
        }
        history = replaceInItems(history, result.data);
      });

      const sortedHistory = history.sort((a, b) => b.datePosted - a.datePosted);

      dispatch({ type: UPDATE_ITEM_HISTORY, history: sortedHistory });
    } catch (e) {
      console.error(e);
      dispatch({ type: SHOW_ERROR, message: e });
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

export function batchReviseItems(items) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      const result = await api.item.batchUpdateItems(items);

      if (result.success) {
        let { history } = getState().marketplace;
        history = Immutable.asMutable(history, { deep: true });

        items.forEach(update => {
          const i = history.findIndex(item => item.id === update.id);
          if (i === -1) return;
          if (update.weight !== undefined) history[i].weight = update.weight;
          if (update.pickupWeight !== undefined) history[i].pickUpWeight = update.pickupWeight;
        });

        dispatch({ type: UPDATE_ITEM_HISTORY, history });
      } else {
        dispatch({ type: SHOW_ERROR, message: result.error });
      }
    } catch (e) {
      console.error(e);
      dispatch({ type: SHOW_ERROR, message: e });
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

export function getHistory(silent = false, deliveredDate = null) {
  return async function (dispatch, getState) {
    try {
      if (!silent) dispatch({ type: SHOW_LOADING });
      dispatch({ type: UPDATE_ITEM_HISTORY, history: [] });
      const result = await api.item.getItems(Roles.RECIPIENT, false, null, null, deliveredDate);

      if (result.success) {
        const sortedItems = result.data.sort(
          (a, b) => b.dateDelivered - a.dateDelivered
        );

        dispatch({ type: UPDATE_ITEM_HISTORY, history: sortedItems });
      } else {
        dispatch({ type: SHOW_ERROR, message: result.error });
      }
    } catch (e) {
      console.error(e);
    } finally {
      if (!silent) dispatch({ type: HIDE_LOADING });
    }
  };
}
export function createManualDonation(data) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      const result = await api.item.addItem(data);

      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
        return;
      }
      let { history } = getState().marketplace;
      history = Immutable.asMutable(history);

      history = addItem(history, result.data);
      const sortedItems = history.sort(
        (a, b) => b.dateDelivered - a.dateDelivered
      );
      dispatch({ type: UPDATE_ITEM_HISTORY, history: sortedItems });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

export function deleteItem(id) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });
      const result = await api.item.deleteItem(id);
      
      console.log('result ', result);
      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
        return;
      }
      let { history } = getState().marketplace;
      history = Immutable.asMutable(history);

      let itemIdx = history.findIndex(item => item.id === id);
      if (itemIdx === -1) {
        dispatch({ type: SHOW_ERROR, message: "Could not find item." });
        throw new Error("Could not find item.");
      }

      history.splice(itemIdx, 1);
      dispatch({ type: UPDATE_ITEM_HISTORY, history });
      
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}